import { Spin } from 'antd';
import s from './style.module.scss';
const GrtLoading = ({ spinning, ...props }) => {
    return (
        <div className={s['loading-box']}>
            <Spin spinning={true} {...props}></Spin>
        </div>
    );
};
export default GrtLoading;
